import {environment} from "environments";

class GpAddressService {
  constructor($http, Endpoints, Utils) {
    Object.assign(this, {
      $http,
      Endpoints,
      Utils,
      BOD_103: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
    });
  }

  getGpAddresses(queryParams) {
    const query = this.Utils.buildJsonApiParams(queryParams);

    return this.$http.get(this.Endpoints.gpAddress.getAllAddresses + query).then(data => data.data);
  }

  getPendingGpLetters(queryParams) {
    const query = this.Utils.buildJsonApiParams(queryParams);

    return this.$http.get(this.Endpoints.gpAddress.getPendingGpLetters + query).then(data => data.data);
  }

  updateAddress(id, address) {
    return this.$http.put(this.Endpoints.gpAddress.updateAddress.replace(':id', id), {
      data: {
        type: 'gpaddresses',
        attributes: {
          ...address,
        },
      },
    });
  }

  printLetters(letters) {
    return this.$http.post(this.Endpoints.gpAddress.printLetters, { orders: letters }, { responseType: 'blob' });
  }

  verifyLetterPrinted(letters) {
    return this.$http.put(this.Endpoints.gpAddress.verifyLettersPrinted, { orders: letters });
  }
}

GpAddressService.$inject = ['$http', 'Endpoints', 'Utils'];
angular.module('pims').service('GpAddress', GpAddressService);
